import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'mobx-react'
import { SnackbarProvider } from 'notistack'
import { registerMicroApps, start } from 'qiankun'
import App from './app/App'
import stores, { initStore } from '@stores'
import { microAppLifyCycle, getMicroAppsConfig } from './micro.const'
import { initI18n } from '@common/i18n'
import { getSensitiveList } from '@utils'

import { renderIECompatibility } from './app/components/ie-compatibility'

const render = async (props: { appContent: string; loading: boolean, routes: any }) => {
  const isIE11 = renderIECompatibility()
  if (isIE11) {
    return
  }
  if (global.$showLoading) {
    global.$showLoading(props.loading)
  }

  const {customRoute, defaultRoutes, horizontalRoutes} = await import('./routes')
  ReactDOM.render(
    <Provider {...stores}>
      <SnackbarProvider
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        maxSnack={3}
        preventDuplicate={true}
      >
        <App
          UserStore={stores.UserStore}
          AppStore={stores.AppStore}
          routes={props.routes || []}
          customRoute={customRoute}
          themeRoutes={stores.AppStore.theme.id === 'default' ? defaultRoutes : horizontalRoutes}
        />
        <div dangerouslySetInnerHTML={{ __html: props.appContent }} />
      </SnackbarProvider>
    </Provider>,
    document.getElementById('root')
  )

  // 初始化敏感词库
  getSensitiveList()

  initStore()
}

;(async () => {
  // 加载语言
  await initI18n(process.env.PUBLIC_URL + '/lang')
  const routes = (await import('./routes')).default
  render({ appContent: '', loading: false, routes }).then()
})()

registerMicroApps(getMicroAppsConfig(render), microAppLifyCycle())
// sandbox为false，否则无法支持动态加载子应用的样式文件且无法支持IE
start({ prefetch: false, sandbox: false, singular: true })
